import { render, staticRenderFns } from "./FailureTrackingForm.vue?vue&type=template&id=0d87e476&scoped=true&"
import script from "./FailureTrackingForm.vue?vue&type=script&lang=ts&"
export * from "./FailureTrackingForm.vue?vue&type=script&lang=ts&"
import style0 from "./FailureTrackingForm.vue?vue&type=style&index=0&id=0d87e476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d87e476",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VTextField,VTextarea})
